import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  Pressable,
  StatusBar,
  View,
  Text,
} from "react-native";
import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";

import {
  updateData,
  updateDataImage,
} from "../../../../services/Profile/profileService";
import styles from "../../styles/profileStyle";
import TopIconView from "../../../Auth/components/TopIconView";
import TextView from "../../../../components/CustomComponent/TextView";
import CustomComponent from "../../../../components/CustomComponent";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import OnBoardingIcons from "../../../../assets/Icons/OnBoardingIcons";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { handleBackButton } from "../../components/BackButtonAlert";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { TouchableOpacity } from "react-native-gesture-handler";

const CompanyAdd = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [company, setCompany] = useState("");
  const [currentPosition, setCurrentPosition] = useState("");
  const handleTextChange1 = (text: string) => {
    setCurrentPosition(text);
  };
  const handleTextChange2 = (text: string) => {
    setCompany(text);
  };
  const handleNextButton = async () => {
    const updateUser = {
      userInfo: {
        company: company,
        currentPosition: currentPosition,
      },
    };
    await updateDataImage(updateUser);
    await updateData({ steps: 6 });
    navigation.navigate("social-link-add" as never);
  };

  const validateName = () => {
    if (company.length < 1 || currentPosition.length < 1) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30,
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <Pressable onPress={Keyboard.dismiss} style={{ flex: 1 }}>
        <View
          style={{
            flex: 1,
            paddingHorizontal: 25,
            gap: 16,
          }}
        >
          {/* <TopIconView
              icon={<OnBoardingIcons.NameIcon />}
              totalScreens={4}
              currentScreen={1}
            /> */}
          <View
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <View style={{ width: "18%", backgroundColor: "black" }}></View>
            <View style={{ width: "50%" }}>
              <TopIconView
                icon={<OnBoardingIcons.NameIcon />}
                currentScreen={6}
                totalScreens={10}
              />
            </View>
            <TouchableOpacity
              onPress={() => navigation.navigate("social-link-add" as never)}
            >
              <Text
                style={{
                  color: "#C0A46F",
                  textDecorationLine: "underline",
                  fontSize: 15,
                }}
              >
                Skip
              </Text>
            </TouchableOpacity>
          </View>
          <View style={{ flex: 1 }}>
            <TextView
              title="What do you do?"
              textStyle={[
                GlobalStyles.heading3,
                {
                  fontFamily: "EBGaramondSemiBold",
                  fontSize: 34,
                  lineHeight: 37,
                  letterSpacing: -0.3,
                },
              ]}
            />
            <View style={{ gap: 8, marginTop: 14 }}>
              <View style={{ width: "100%", height: 48, marginBottom: 5 }}>
                <CustomComponent.InputField
                  placeholder="Your profession"
                  keyboardtype="default"
                  onTextChange={handleTextChange1}
                />
              </View>
              <View style={{ paddingLeft: 10, paddingVertical: 4 }}>
                <OnBoardingIcons.SymbolIcon />
              </View>
              <View style={{ width: "100%", height: 48 }}>
                <CustomComponent.InputField
                  placeholder="Company name"
                  keyboardtype="default"
                  onTextChange={handleTextChange2}
                />
              </View>
            </View>
          </View>
        </View>
        <BottomView
          enableTitle={false}
          onPress={handleNextButton}
          disableBtn={validateName()}
          style={{ paddingBottom: 20 }}
        />
      </Pressable>
    </SafeAreaView>
  );
};

export default CompanyAdd;
